import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Grid, Snackbar } from '@material-ui/core';
import { FormEdit, Errors, Components } from '@formio/react';
import FormioProvider from '../../../providers/FormioProvider';
import { objAtrib, objText, properties } from './CreacionFormulariosData';
import { style, objStyle } from './CreacionFormulariosStyle';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import es from '../../../translations/es';
import '../../../BootstrapWrapper.scss';
import './CreacionFormulariosStyle.css'
import components from '../../commons/customComponentsFormio/componentDispatcherFormio';
import useOperations from './CreacionFormulariosFunction';
import Confirmacion from 'components/commons/Confirmacion/Confirmacion';
import { Alert } from '@material-ui/lab';
import {properties as appProperties} from '../../../AppData';
import { properties as propertiesCloudConfig } from 'config/Config';

Components.setComponents(components);

export default function CreacionFormularios() {

     const useStyles = makeStyles((theme) => ({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1,
            color: '#fff',
        },
        root: {
            marginTop: '15px',
        },
        backButton: {
            marginLeft: '2em',
            marginBottom: '1em',
        },
    }));

    const { updateFormat, isPhoneVersion, cancelarContinuacion, mostrarPopUp, aceptarContinuacion, redirectModuloAdmin, buildButtonJS, alerts, setMessage, message, handleSetMessage } = useOperations();
    const customStyle = style();
    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const { formPath } = useParams();
    const [form, setForm] = useState({ display: 'form', language: 'es' });
    const [errors, setErrors] = useState(null);
    const prevLocation = 'edicion';
    const history = useHistory();
    const { formioOperation, checkAppToken } = FormioProvider();
    const [options, setOptions] = useState();
    const esEdicion = formPath ? true : false;

    useEffect(()=>{
        montarOptions();
    }, []);

    const montarOptions = () =>{
        let urlFormio = propertiesCloudConfig['CECEU_FORMIO_SERVER'];
        const obj = {
            language: 'es',
            i18n: {
                'es': es
            },
            builder: {
                basic: {
                    components: {
                        selectSimple: true,
                        selectAutocomplete: true
                    }
                },
                advance: false //Habilita o deshabilita el apartado de los componentes advance
            },
            base: urlFormio,
            project: `${urlFormio}/project`,
            resourceTag: properties.resourceTag,
        };
        setOptions(obj);
    };

    useEffect(() => {        
        if (formPath) {
            setLoading(true);
            formioOperation(formPath, { method: 'get' })
                .then(response => {
                    setForm(response.data);
                    setErrors(null);
                })
                .catch(error => {
                    setErrors(error.response.data);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [formPath]);

    useEffect(() => {
        document.querySelector("label[for=title]").innerText = es.title;
        document.querySelector("input#title").placeholder = es.title_desc;
        document.querySelector("input#title").title = es.title_tooltip;
        document.querySelector("label[for=name]").innerText = es.name;
        document.querySelector("input#name").placeholder = es.name_desc;
        document.querySelector("input#name").title = es.name_tooltip;
        document.querySelector("label[for=name]:not(.field-required)").innerText = es.display_as;
        document.querySelector("select#form-display").parentElement.title = es.display_as_tooltip;
        document.querySelector("label[for=form-type]").innerText = es.type;
        document.querySelector("select#form-type").parentElement.title = es.type_tooltip;
        document.querySelector("label[for=path]").innerText = es.path;
        document.querySelector("input#path").placeholder = es.path_desc;
        document.querySelector("input#path").title = es.path_tooltip;
        document.querySelector('div#save-buttons').setAttribute('class', 'save-back-btn');
        document.querySelector('#gridContenedor > div:nth-child(1)').setAttribute('id', 'containerCreacionForm');
        document.querySelector('#containerCreacionForm > div:nth-child(1)').setAttribute('id', 'cabeceraCreacionForm');
        document.querySelector('#containerCreacionForm > div:nth-child(2)').setAttribute('id', 'containerComponents');
        buildButtonJS("div#save-buttons", objAtrib.button, objText.tituloBotonAtras, redirectModuloAdmin);
        let displayOptions = document.querySelector("select#form-display").options;

        if (displayOptions) {
            for (let opt of displayOptions) {
                if (es[opt.label]) {
                    opt.label = es[opt.label];
                }
            }
        }

        let typeOptions = document.querySelector("select#form-type").options;
        if (typeOptions) {
            for (let opt of typeOptions) {
                if (es[opt.label]) {
                    opt.label = es[opt.label];
                }
            }
        }
        updateFormat();
        return () => window.removeEventListener('resize', updateFormat);
    }, []);

    window.addEventListener('resize', updateFormat);

    const titulo = esEdicion ? "Editar formulario" : "Crear nuevo formulario";

    const handleSubmit = (form) => {
        setLoading(true);
        const operation = formPath
            ? formioOperation(formPath, { method: 'put', data: form }, true)
            : formioOperation('form', { method: 'post', data: form }, true);

        operation.then(response => {
            if (!formPath) {
                history.push({
                    pathname: `/CreacionFormularios/${response.data.path}`,
                    state: {
                        from: "edicion"
                    }
                })
            }
            setErrors(null);
            handleSetMessage('Se ha realizado correctamente el guardado del formulario', 'success');
        }).catch(error => {
            if (error.response && error.response.data) {
                if (error.response.data.message && error.response.data.message.match('^form validation failed')) {
                    setErrors(error.response.data);
                    handleSetMessage('No se ha realizado correctamente el guardado del formulario', 'danger');
                }
            }
        }).finally(() => {
            setLoading(false);
        });
    }


    return (
        //Grid principal
        <Grid className="formioBuilderScope" container spacing={12} {...objAtrib.gridPrincipal}>
            {/*Titulo*/}
            <h2 id="tituloPaginaFormBuilder" className={customStyle.classH2}>{objText.tituloEncabezado}</h2>
            {/*POPUP*/}
            <Confirmacion
                {...objText.popup}
                isPhoneVersion={isPhoneVersion}
                handleChange={cancelarContinuacion}
                mostrar={mostrarPopUp}
                accionConfirmacion={(e) => aceptarContinuacion(e)}
                tamMarginTop={appProperties.COMFIRMAR_MARGINTOP_10}
                isPopUpPdf={false}
                textBotonConfirmarPersonalizado={false}
                isImagenPersonalizada={false}
                centrarContenido={true}
                isTextoEnriquecido={true}
            />
            {/*Grid contenedor*/}
            <Grid container spacing={3} {...objAtrib.gridContenedor} className={customStyle.classGridContenedor}>
                <Errors errors={errors} />
                {
                    <FormEdit form={form} options={options} saveText="Guardar" saveForm={handleSubmit} />
                }
                <Backdrop className={customStyle.classBackdrop} open={loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                {alerts.map(m => (
                    <Snackbar open={message.msg} autoHideDuration={5000} onClose={() => setMessage({ severity: "", msg: "" })}>
                        <Alert
                            severity={message.severity}
                            variant="filled"
                        >
                            {message.msg}
                        </Alert>
                    </Snackbar>
                ))}
            </Grid>
        </Grid>
    );
}